import TranslationAiTableHelper from "./translation-ai-table-helper";
import TranslationAiPricingHelper from "./translation-ai-pricing-helper";
import TranslationAiFormatHelper from "./translation-ai-format-helper";
import TranslationAiLanguageHelper from "./translation-ai-language-helper";


const SettingsHelpers = {
    TranslationAiTable: TranslationAiTableHelper,
    TranslationAiPricing: TranslationAiPricingHelper,
    TranslationAiFormat: TranslationAiFormatHelper,
    TranslationAiLanguage: TranslationAiLanguageHelper,
};

export default SettingsHelpers;
